import React from 'react';

import {keywords as _keywords} from './keywords';

const ArrayToKeys=(array)=>{
    const key="key";
    const uniqueKeys = [...new Set(array.map(o=>o[key]))];    
    return uniqueKeys.reduce((acc,uniqueKey)=>({...acc,[uniqueKey]:array.find(o=>o[key]==uniqueKey)}),{});
};

const keywords=ArrayToKeys(_keywords);

const Context = React.createContext();

export const useLanguage = ()=>React.useContext(Context);

export const Provider =  ({children,lng:_lng})=> {
  const [lng, setLng] = React.useState(_lng||"en");  
  return  <Context.Provider value={{lng,keywords,setLng}}>
    {children}
  </Context.Provider>;
}

export default ({id})=>{
  
  
  const {lng="en",keywords={}} = useLanguage()||{};
  return keywords?.[id]?.[lng] ?? "Error - Keyword not found"  ;
}